// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TNdvNuwppCfXLbXZSkNg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0.75rem;
  background-color: rgba(30, 30, 30, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: white;
  cursor: pointer;
  transition: all 0.15s ease;
  backdrop-filter: blur(8.5px);
  -webkit-backdrop-filter: blur(8.5px);
}
.TNdvNuwppCfXLbXZSkNg:hover:not(.YXut49vuIjmxhMUEoE2L) {
  border-color: rgba(255, 255, 255, 0.25);
  background-color: rgb(38, 38, 38);
}
.TNdvNuwppCfXLbXZSkNg:focus {
  outline: none;
  border-color: #774dee;
  box-shadow: 0 0 0 2px rgba(119, 77, 238, 0.2);
}
.TNdvNuwppCfXLbXZSkNg.YXut49vuIjmxhMUEoE2L {
  opacity: 0.5;
  cursor: not-allowed;
}

.ZygSGYQoNIn90XovkryG {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.tSlXLS2QAcqpJL5ru2sy {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.6);
  transition: transform 0.2s ease;
  margin-left: 8px;
}

.TNdvNuwppCfXLbXZSkNg[data-state=open] .tSlXLS2QAcqpJL5ru2sy {
  transform: rotate(180deg);
}

.wHY76luXsBdjUJd3S4Un {
  min-width: 240px;
  max-height: 400px;
  overflow-y: auto;
  background-color: rgba(30, 30, 30, 0.95);
  color: white;
  border-radius: 8px;
  padding: 6px;
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index: 1000;
  backdrop-filter: blur(8.5px);
  -webkit-backdrop-filter: blur(8.5px);
}

.RkuIFZz99oDR7cpL8fhK {
  margin-bottom: 0;
}

.LLlaP9a0xqJCcXIQHDQ3 {
  font-size: 11px;
  font-weight: 600;
  padding: 8px 12px 4px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.yNDxF4lBaKj4YVUxlfHU {
  all: unset;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.2;
  border-radius: 6px;
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 8px 12px;
  position: relative;
  user-select: none;
  cursor: pointer;
  margin: 1px 0;
  transition: background-color 0.15s ease-in-out;
  color: white;
}
.yNDxF4lBaKj4YVUxlfHU[data-highlighted] {
  background-color: rgba(255, 255, 255, 0.1);
  outline: none;
}
.yNDxF4lBaKj4YVUxlfHU.rlHyx3gmXn1ycKUcZkaH {
  background-color: rgba(119, 77, 238, 0.2);
  color: #c4b5fd;
  font-weight: 500;
}

.UD8zzX6hBr5ShtPrizZl {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.CwEGqcFHe90CbBMZgTZg {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
  flex-shrink: 0;
}

.qIusoDnlT0c0XhAtNee9 {
  flex: 1;
  text-align: left;
}

.VqM1A0zrwIjahPCw_uue {
  padding: 0.25rem 0.375rem !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 0.25rem !important;
  flex-shrink: 0;
  color: #9ca3af;
}
.rlHyx3gmXn1ycKUcZkaH .VqM1A0zrwIjahPCw_uue {
  background-color: rgba(119, 77, 238, 0.3) !important;
  color: #e0d4ff;
}

.pEeLKOHdFGrtyUFQWMbF {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 4px 4px 6px;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/AIModelSelector/AIModelSelector.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;EACA,wCAAA;EACA,2CAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;AAFF;AAIE;EACE,uCAAA;EACA,iCAAA;AAFJ;AAKE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAHJ;AAME;EACE,YAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;AALF;;AAQA;EACE,cAAA;EACA,+BAAA;EACA,+BAAA;EACA,gBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iGACE;EAEF,yBAAA;EACA,wDAAA;EACA,+BAAA;EACA,aAAA;EACA,4BAAA;EACA,oCAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,UAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,8CAAA;EACA,YAAA;AAPF;AASE;EACE,0CAAA;EACA,aAAA;AAPJ;AAUE;EACE,yCAAA;EACA,cAAA;EACA,gBAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AATF;;AAYA;EACE,OAAA;EACA,gBAAA;AATF;;AAYA;EACE,oCAAA;EACA,qDAAA;EACA,iCAAA;EACA,cAAA;EACA,cAAA;AATF;AAWE;EACE,oDAAA;EACA,cAAA;AATJ;;AAaA;EACE,WAAA;EACA,0CAAA;EACA,mBAAA;AAVF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `TNdvNuwppCfXLbXZSkNg`,
	"disabled": `YXut49vuIjmxhMUEoE2L`,
	"selectedModel": `ZygSGYQoNIn90XovkryG`,
	"arrow": `tSlXLS2QAcqpJL5ru2sy`,
	"content": `wHY76luXsBdjUJd3S4Un`,
	"group": `RkuIFZz99oDR7cpL8fhK`,
	"groupLabel": `LLlaP9a0xqJCcXIQHDQ3`,
	"item": `yNDxF4lBaKj4YVUxlfHU`,
	"selected": `rlHyx3gmXn1ycKUcZkaH`,
	"itemContent": `UD8zzX6hBr5ShtPrizZl`,
	"modelLogo": `CwEGqcFHe90CbBMZgTZg`,
	"modelName": `qIusoDnlT0c0XhAtNee9`,
	"tokenCostBadge": `VqM1A0zrwIjahPCw_uue`,
	"separator": `pEeLKOHdFGrtyUFQWMbF`
};
export default ___CSS_LOADER_EXPORT___;
